import { RootState } from '@/store/main';
import { Channel } from '@/types/channel.types';
import { BLAdmin } from '@/types/profile.types';
import { FeatureFlagsEnum } from '../feature-flags/types';

export const getToken = (state: RootState): string | null => state.user.idToken;
export const getUser = (state: RootState): BLAdmin | null => state.user.user;
export const getActiveChannel = (state: RootState): number | null => state.user?.user?.active_channel || null;
export const selectUserChannel = (state: RootState): Channel | null => {
  const activeChannel = getActiveChannel(state);
  return state.channels.channels?.find((channel) => channel.channel === activeChannel) || null;
};
export const getChangingChannels = (state: RootState): boolean => state.user.changingChannels;
export const getSigningOut = (state: RootState): boolean => state.user.signingOut;
export const getBetaFlagOptIns = (state: RootState): FeatureFlagsEnum[] | undefined => state.user?.user?.beta_opt_ins;
